export default "/app/themes/macleod/public/images/chevron-left.svg?66bfeb1a0ef02334c6b5cbf5d7df9ec0";